<template>
	<div v-if="content && fundData" class="msrating-tooltip container">
		<div
			v-if="fundData.ratingOverall"
			class="msrating-tooltip__overall-section"
		>
			<div class="msrating-tooltip__heading">
				<div class="msrating-tooltip__heading-text">
					<h2 class="p3 --bold" v-html="content.ratingDefinitionHeading" />
				</div>

				<div class="msrating-tooltip__heading-stars" aria-hidden="true">
					<span
						v-for="(rating, index) in fundData.ratingOverall"
						class="icon icon-star"
						:key="`golden-star${index}`"
					/>
					<span
						v-for="(rating, index) in 5 - fundData.ratingOverall"
						class="icon icon-star --grey"
						:key="`grey-star${index}`"
					/>
				</div>

				<div class="msrating-tooltip__rating-text">
					<p class="p3">
						{{ fundData.ratingOverall }} {{ content.outOfFiveStars }}
					</p>
				</div>
			</div>
			<p v-html="ratingDefinition" />
		</div>

		<div class="msrating-tooltip__determined">
			<div class="msrating-tooltip__heading">
				<h2 class="p3" v-html="content.howIsItDeterminedHeading" />
			</div>
			<p v-html="content.howIsItDeterminedText" />
		</div>

		<div
			v-if="fundData.rating3Yr || fundData.rating5Yr || fundData.rating10Yr"
			class="msrating-tooltip__years-section"
		>
			<template v-for="(year, index) in yearRatings">
				<div
					class="msrating-tooltip__year-rating"
					v-if="year.rating"
					:key="`year-rating${index}`"
				>
					<div class="msrating-tooltip__year-rating-stars" aria-hidden="true">
						<span
							v-for="(rating, starIndex) in year.rating"
							class="icon icon-star"
							:key="`golden-star${starIndex}`"
						/>
						<span
							v-for="(rating, greyStarIndex) in 5 - year.rating"
							class="icon icon-star --grey"
							:key="`grey-star${greyStarIndex}`"
						/>
					</div>

					<div class="msrating-tooltip__year-text">
						<span class="p4">
							<span class="--bold">{{ year.label }}</span>
							{{ year.rating }} {{ content.outOfFiveStars }}
						</span>
					</div>
				</div>
			</template>
		</div>

		<span v-if="isSmall" @click.prevent="closeMorningstarModal">
			<CTA
				:url="content.disclaimerTargetURL"
				:text="content.viewCompleteDisclosures"
				chevron="right"
			/>
		</span>

		<span v-else>
			<CTA
				:url="content.disclaimerTargetURL"
				:text="content.viewCompleteDisclosures"
				chevron="right"
				role="button"
			/>
		</span>
		<v-breakpoint v-model="model" />
	</div>
</template>

<script>
import CTA from "../cta/CTA";
import { EventBus, VBreakpoint, Model } from "@vg-faset/core";
import * as replaceContent from "@vg-faset/core/js/filters/string/replaceContent";

export default {
	name: "MorningstarRatingTooltip",

	components: {
		CTA,
		VBreakpoint
	},

	data() {
		return {
			model: new Model()
		};
	},

	props: {
		content: {
			type: Object,
			default: () => {}
		},

		fundData: {
			type: Object,
			default: () => {}
		},

		sizeOverall: {
			type: String,
			default: "-"
		}
	},

	computed: {
		isSmall() {
			return this.model.isSmall;
		},

		ratingDefinition() {
			return replaceContent.default(
				this.content.ratingDefinitionText,
				this.definitionVars
			);
		},

		definitionVars() {
			return {
				overallRating: this.fundData.ratingOverall,
				overallNumberOfFunds: this.sizeOverall,
				categoryName: this.fundData.categoryName
			};
		},

		yearRatings() {
			return [
				{
					label: this.content.threeYears,
					rating: this.fundData.rating3Yr
				},
				{
					label: this.content.fiveYears,
					rating: this.fundData.rating5Yr
				},
				{
					label: this.content.tenYears,
					rating: this.fundData.rating10Yr
				}
			];
		}
	},

	methods: {
		closeMorningstarModal() {
			EventBus.$emit("modal:hide");
		}
	}
};
</script>

<style lang="scss" scoped>
.msrating-tooltip {
	&__overall-section {
		margin-bottom: 20px;
	}

	&__heading {
		h2 {
			margin-bottom: 10px;
		}
	}

	&__heading-text {
		display: inline-block;
	}

	&__heading-stars {
		display: inline-block;
		vertical-align: 2px;
		font-size: 0;
		margin-bottom: 8px;
	}

	&__rating-text {
		display: inline-block;

		p {
			display: block;
		}
	}

	&__years-section {
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;

		@include to-md() {
			display: block;
		}
	}

	&__year-rating {
		margin-right: 4px;
		flex-direction: column;
	}

	&__year-rating-stars {
		font-size: 0;
		margin-left: -3px;

		@include to-md() {
			display: inline-block;
			vertical-align: 2px;
			margin-bottom: 8px;
		}
	}

	&__year-text {
		letter-spacing: 0;

		@include to-md() {
			display: inline-block;
		}
	}

	p {
		@include to-md() {
			font-size: 14px;
			margin-bottom: 20px;
		}
	}

	.icon-star {
		margin-right: 4px;
		color: $color--golden;
		display: inline-block;
		font-size: 20px;
		line-height: 24px;
		margin-bottom: 8px;
		vertical-align: middle;

		&.\--grey {
			color: $color--light-gray;
		}
	}
}
</style>
